import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  "info-page": defineAsyncComponent(() => import("/app/layouts/info-page.vue").then(m => m.default || m))
}